import React from 'react';

import {PlaceholderWrapperComponent} from "../../../../../../core/components/placeholder/placeholder-wrapper";
import {GameInfoModuleRowPlaceholder} from "./game-info-module.row.placeholder";
import {WithDevice} from "../../../../../../core/components/composers/with-device";
import classnames from "classnames";
import styles from "../../styles/game-info-module.module.scss";


export const GameInfoModulePlaceholder = WithDevice(() => {
  return (
    <PlaceholderWrapperComponent className={classnames(styles.placeholder)}>
      <div className={classnames(styles.placeholder_content)}>
        <GameInfoModuleRowPlaceholder/>
        <GameInfoModuleRowPlaceholder/>
        <GameInfoModuleRowPlaceholder/>
      </div>
    </PlaceholderWrapperComponent>
  )
});
